import { Client } from "../models/ByClients/Client";
import { Declarant } from "../models/Declarant";
import isNaN from "../helpers/number";

type Row = string | number;

export default function (rows: Row[], data: Client[]): Declarant[] {
  const entities: Declarant[] = [];

  data.forEach((client) => {
    if (!Array.isArray(client.children)) {
      return;
    }

    entities.push(
      // @ts-ignore
      ...client.children.filter(
        (item) => !isNaN(item.id) && rows.includes(item.id as Row)
      )
    );
  });

  return entities;
}
